/**
 * This class holds information related to WiFi Access point like SSID,
 * password, security type and RSSI.
 */
export class WiFiAccessPoint {
    private wifiName?: string; // SSID
    private rssi?: number;
    private security?: number;
    private password?: string;

    public getWifiName(): string | undefined {
        return this.wifiName;
    }

    public setWifiName(wifiName: string): void {
        this.wifiName = wifiName;
    }

    public getRssi(): number | undefined {
        return this.rssi;
    }

    public setRssi(rssi: number): void {
        this.rssi = rssi;
    }

    public getSecurity(): number | undefined {
        return this.security;
    }

    public setSecurity(security: number): void {
        this.security = security;
    }

    public getPassword(): string | undefined {
        return this.password;
    }

    public setPassword(password: string): void {
        this.password = password;
    }
}
